import { isIOS as r, isAndroid as t } from "@walletconnect/utils";
const o = () => r() || t(), p = () => {
  const s = navigator.userAgent;
  return /OKApp/i.test(s);
};
export {
  o as isIosOrAndroid,
  p as isOkxApp
};
//# sourceMappingURL=index.js.map
